import { render, staticRenderFns } from "./EscolhaPerfil.vue?vue&type=template&id=4a0c40ac&scoped=true&"
import script from "./EscolhaPerfil.vue?vue&type=script&lang=js&"
export * from "./EscolhaPerfil.vue?vue&type=script&lang=js&"
import style0 from "./EscolhaPerfil.vue?vue&type=style&index=0&id=4a0c40ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c40ac",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a0c40ac')) {
      api.createRecord('4a0c40ac', component.options)
    } else {
      api.reload('4a0c40ac', component.options)
    }
    module.hot.accept("./EscolhaPerfil.vue?vue&type=template&id=4a0c40ac&scoped=true&", function () {
      api.rerender('4a0c40ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/EscolhaPerfil/EscolhaPerfil.vue"
export default component.exports